export default __webpack_public_path__ + "static/media/e22b454b077582fbefe6c887e89788bf.svg";